const divSignUpTenantsCards = {
  header: 'Seleccione su empresa: *',
  headerError: 'Seleccione una empresa'
};

export default divSignUpTenantsCards;
